import { VerticalLayout } from "./layout"
import { relativeTime } from "../api/date_formatting"
import { IconAlignJustified } from "@tabler/icons-react"

export function ChatBox({ onClick, chatData = {}, activeChat }) {
    return (
        <div aria-label="chat-box" onClick={onClick} className={`horizontal small-standard-padding ${(activeChat) ? 'grey-background-100' : 'card-background-color'} chat-box`} style={{width:"unset"}}>
            <VerticalLayout style={{width:"unset", marginRight:"0.5rem", justifyContent:"center", alignItems:"center"}}>
                <img alt="avatar" className='small-img rounded-img' src={chatData.image_url ? chatData.image_url : `https://ui-avatars.com/api/?name=${chatData.title || "No image"}`}/>
            </VerticalLayout>
            <VerticalLayout style={{"marginLeft":"0.5rem"}}>
                <div className="horizontal space-between">
                    <p style={{ fontWeight: chatData.newMessage ? "700" : "600" , }} className={`truncrate-title small-text ${(chatData.active)?'primary-600':'standard-text-color'}`} >{chatData.title} {chatData.responder_first_name} {chatData.responder_last_name}</p>
                    {chatData.newMessage ? <div className="" style={{borderRadius:100, minHeight:"1rem", maxHeight:"1rem", minWidth:"1rem", maxWidth:"1rem", marginRight:"1rem", backgroundColor:"var(--primary-600)"}}></div>: <p className={'xsmall-text standard-text-color-light'}  style={{textAlign:"right"}}>{chatData.last_message_sent_at ? relativeTime(new Date(chatData.last_message_sent_at)) : ""}</p>}
                </div>
                <div className="horizontal space-between">
                    <p style={{width: "150px"}} className={'xsmall-text standard-text-color-light truncrate-title'}>{chatData.last_message_content}</p>
                    <p className="full-circle grey-background-200"></p>
                </div>
            </VerticalLayout>
        </div>
    )
}
export function ChatBoxInSide({ chatData= {}, active }) {
    return (
        <div className={`horizontal small-standard-padding ${(active) ? 'grey-background-100' : 'card-background-color'}`} style={{width:"unset"}}>
            <VerticalLayout style={{width:"unset", marginRight:"0.5rem", alignItems:"center", justifyContent:"center"}}>
                <img alt="avatar" src={`https://ui-avatars.com/api/?name=${chatData.sender_first_name}+${chatData.sender_last_name}&background=random&color=fff&format=svg`} className='small-img rounded-img' />
            </VerticalLayout>
            <VerticalLayout>
                <div className="horizontal space-between">
                    <p className={`small-text bold-text ${(active)?'primary-600':'standard-text-color'}`}>{chatData.sender_first_name} {chatData.sender_last_name}</p>
                    <p className={'xsmall-text standard-text-color-light'}>{relativeTime(new Date(chatData.sent_at))}</p>
                </div>
                <div className="horizontal standard-padding standard-border small-rounded" style={{maxWidth:"50%"}}>
                    <p className={'xsmall-text standard-text-color-light'}>{chatData.message_content}</p>
                </div>
            </VerticalLayout>
        </div>
    )
}